(function() {
  'use strict';
  angular.module('benefits')
  .filter('waitingPeriod', ['benefitService', function(benefitService) {
    return function(waitPeriod, effectiveDate) {
      return benefitService.waitingPeriod(waitPeriod, effectiveDate).text;
    };
  }]);
})();
